// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-result-popup .action[data-v-7c6ef097]{display:flex;flex-direction:column}.modal-popup[data-v-7c6ef097]  .modal{padding:65px 30px 20px 30px}h1[data-v-7c6ef097]{text-align:center;font-family:\"Instrument Serif\",Georgia,Times New Roman,serif;font-style:normal;font-weight:400;font-size:28px;line-height:38px}", ""]);
// Exports
module.exports = exports;
